import { message } from 'antd';
import { customInstance } from '@/shared/api/mutator/custom-instance';
import { AttendanceRecord } from '../types';

export function useAttendance() {
  const fetchByEmployee = async (employeeId: number, from: string, to: string) => {
    try {
      return await customInstance<AttendanceRecord[]>({
        url: `/api/hr/attendance/employee/${employeeId}?from=${from}&to=${to}`,
        method: 'GET',
      });
    } catch {
      message.error('Failed to load attendance');
      return [];
    }
  };

  const fetchByDateRange = async (from: string, to: string) => {
    try {
      return await customInstance<AttendanceRecord[]>({
        url: `/api/hr/attendance?from=${from}&to=${to}`,
        method: 'GET',
      });
    } catch {
      message.error('Failed to load attendance records');
      return [];
    }
  };

  const recordAttendance = async (dto: Partial<AttendanceRecord>) => {
    try {
      const data = await customInstance<AttendanceRecord>({ url: '/api/hr/attendance', method: 'POST', data: dto });
      message.success('Attendance recorded');
      return data;
    } catch {
      message.error('Failed to record attendance');
    }
  };

  const updateAttendance = async (id: number, dto: Partial<AttendanceRecord>) => {
    try {
      const data = await customInstance<AttendanceRecord>({ url: `/api/hr/attendance/${id}`, method: 'PUT', data: dto });
      message.success('Attendance updated');
      return data;
    } catch {
      message.error('Failed to update attendance');
    }
  };

  const countOnLeaveToday = async (): Promise<number> => {
    try {
      return await customInstance<number>({ url: '/api/hr/attendance/on-leave/count', method: 'GET' });
    } catch {
      return 0;
    }
  };

  return { fetchByEmployee, fetchByDateRange, recordAttendance, updateAttendance, countOnLeaveToday };
}
